export default __webpack_public_path__ + "static/media/Billing-area.4b00c448.jpg";